export default __webpack_public_path__ + "static/media/S100.844e2548.png";